export const ru = {
  scene: {
    loading: 'Загружаем фон…',
    recovering: 'Восстанавливаем изображение…',
    unavailable: 'Не удалось загрузить фон',
    retryHint:
      'Повторяем попытку. Если загрузка не завершится, откройте приложение снова.',
  },
  bootstrap: {
    unsupportedBrowser: {
      title: 'Этот браузер не поддерживается',
      description: 'В текущей конфигурации браузера графика приложения недоступна. Откройте Neiro Oracle в другом браузере из списка ниже.',
      browsers: 'Поддерживаемые браузеры',
      requirement: 'Используйте актуальную версию с доступной графикой WebGL. Настройки браузера или устройства могут ограничивать её работу.',
      safari: 'Safari · iPhone, iPad и Mac',
    },
    loadingSpace: 'Настраиваем пространство…',
    loadingOracle: 'Пробуждаем оракул…',
    startupError: 'Ошибка запуска',
    retry: 'Попробовать снова',
    staleTelegram:
      'Сессия Telegram устарела. Закройте Mini App и откройте её снова.',
    authTelegramError: 'Не удалось подтвердить вход через Telegram',
    updateTelegramError:
      'Не удалось обновить Mini App. Полностью закройте его и откройте снова.',
    missingTelegramData:
      'Telegram не передал данные запуска. Закройте Mini App и откройте его снова.',
  },
  // Common
  back: 'Назад',
  close: 'Закрыть',
  loading: 'Загрузка...',
  routeReading: {
    loading: 'Открываем запись…',
    error: 'Запись недоступна',
    errorHint: 'Она могла быть удалена или принадлежит другому профилю.',
    retry: 'Повторить',
  },
  save: 'Сохранить',
  tomorrow: 'Завтра',
  collapse: 'Свернуть',

  // App Title
  app: {
    title: 'NEIRO ORACLE',
    subtitle: 'Система гадания v{{version}}',
    version: 'v{{version}}',
  },

  oracleGuide: {
    eyebrow: 'Neiro Oracle',
    title: 'Как работает Oracle',
    introduction: 'Два способа обратиться к И‑Цзин — для разных задач.',
    accessibilityLabel: 'Справка о Знаке дня и гадании',
    open: 'Как пользоваться',
    close: 'Закрыть справку',
    understood: 'Понятно',
    daily: {
      title: 'Знак дня',
      body: 'Вопрос не нужен. Это тема и практический ориентир на день.',
    },
    reading: {
      title: 'Гадание',
      body: 'Сформулируйте один конкретный вопрос и держите его в уме во время броска монет. Гадание покажет текущую ситуацию, перемены и возможное направление.',
    },
    journal: {
      title: 'Дневник',
      body: 'Знаки дня и гадания сохраняются в одной истории. Решение можно зафиксировать после гадания.',
    },
    example: {
      title: 'Хороший вопрос',
      body: '«Что мне стоит учесть перед разговором с командой?»',
    },
  },

  // Home Screen
  home: {
    title: 'NEIRO ORACLE',
    subtitle: 'Система гадания v{{version}}',
    statusText: '> Все системы работают',
    daily: {
      title: 'Знак дня',
      caption: 'Без вопроса · тема и ориентир на день',
      actionTitle: 'Действие на сегодня',
      askNow: 'Начать гадание',
      moreDetails: 'Подробнее',
      hideDetails: 'Скрыть подробности',
      detailsTitle: 'Полное описание',
      lastResult: 'Последний результат',
      noLastResult: 'нет данных',
      emptyState: 'Пока нет гаданий. Начать гадание →',
      empty: {
        subtitle: 'Нажми, чтобы получить знак на сегодня',
        hint: 'Ритуал одного нажатия',
        button: 'Получить знак',
      },
      loading: {
        searching: 'Поиск гексаграммы…',
        revealing: 'Проявляем шесть линий…',
      },
      pinnedToday: 'Закреплено на сегодня',
      newSign: 'Новый знак',
      resetReasons: {
        title: 'Причина обновления',
        sleep: 'Проснулся после сна',
        situationChanged: 'Ситуация изменилась',
        other: 'Другое',
      },
      resetConfirm: {
        title: 'Обновить знак?',
        message:
          'Обновить знак для нового цикла бодрствования? Текущий останется в дневнике.',
        confirm: 'Обновить',
        cancel: 'Отмена',
      },
      nextUpdate: {
        prefix: 'Следующий новый знак —',
        afterSleep: 'после следующего сна',
        tomorrow: 'завтра в 07:00',
        or: 'или',
        available: 'доступен сейчас',
      },
      updated: 'Знак обновлён — новый цикл бодрствования',
      limitReached: 'Достигнут лимит обновлений на сегодня',
      disclaimer:
        'Для саморефлексии и развлечения. Не является медицинской или финансовой консультацией.',
    },
    question: {
      title: 'Есть конкретный вопрос?',
      subtitle: 'Гадание разберёт ситуацию, перемены и возможное направление',
      askNow: 'Начать гадание',
      hint: 'Без темы. Будет будущая гексаграмма, текущая и изменяющиеся линии',
    },
    buttons: {
      iching: 'ОРАКУЛ И-ЦЗИН',
      designSystem: 'ДИЗАЙН СИСТЕМА',
      simpleTest: 'ПРОСТОЙ ТЕСТ',
      hexagramTest: 'ТЕСТ ГЕКСАГРАММ',
    },
  },

  // I-Ching Screen
  iching: {
    title: 'ОРАКУЛ И-ЦЗИН',
    subtitle: 'МОБИЛЬНАЯ v{{version}}',
    throwCoins: 'Бросить монеты',
    castingHexagram: 'Создание гексаграммы…',
    generationError:
      'Знак не сложился. Проверьте соединение и повторите ритуал.',
    retry: 'Повторить',
    castingWisdom: {
      1: 'Путь в тысячу ли начинается с первого шага',
      2: 'Не бойся идти медленно — бойся стоять на месте',
      3: 'Мягкое побеждает твёрдое, тихое — беспокойное',
      4: 'Перемены — единственное, что постоянно под небом',
      5: 'Мудрый принимает форму сосуда, как вода',
      6: 'Когда знак сложился, ответ уже внутри тебя',
    },
    instruction: 'Нажмите для создания гексаграммы и получения наставления',
    linkActive: 'СВЯЗЬ АКТИВНА',
    backButton: '← ДОМОЙ',
    newDivination: 'НОВОЕ ГАДАНИЕ',

    sections: {
      hexagrams: 'ГЕКСАГРАММЫ',
      interpretation: 'ТОЛКОВАНИЕ',
      aiInsights: 'ИИ ИНСАЙТЫ',
      general: 'ОБЩЕЕ ТОЛКОВАНИЕ',
      love: 'ЛЮБОВЬ И ОТНОШЕНИЯ',
      work: 'РАБОТА И КАРЬЕРА',
      health: 'ЗДОРОВЬЕ И БЛАГОПОЛУЧИЕ',
      travel: 'ПУТЕШЕСТВИЯ',
      changingLines: 'ИЗМЕНЯЮЩИЕСЯ ЛИНИИ',
      futureHexagram: 'ВОЗМОЖНОЕ СОСТОЯНИЕ',
      structuralFocus: 'НА ЧЁМ ДЕРЖИТСЯ СИТУАЦИЯ',
    },

    hexagram: {
      current: 'ТЕКУЩАЯ',
      future: 'ВОЗМОЖНАЯ',
      present: 'НАСТОЯЩАЯ СИТУАЦИЯ',
      outcome: 'ВОЗМОЖНОЕ НАПРАВЛЕНИЕ',
      changing: 'ИЗМЕНЯЮЩИЕСЯ ЛИНИИ',
      structural: 'НА ЧЁМ ВСЁ ДЕРЖИТСЯ',
    },

    insights: {
      analyzing: 'Собираем чтение...',
      transformation:
        '«{{current}}» может перейти в «{{future}}». Изменяющихся линий: {{changes}}.',
      stable: 'Линии не меняются. Ситуация сохраняет текущее направление.',
    },

    changingLines: 'Изменяющиеся линии',
    changingLinesDescription:
      'Эти линии показывают, где именно ситуация может измениться.',
    governingLineHint: 'Корона отмечает главную линию гексаграммы.',
    changingLinesTitle: 'Изменяющиеся линии ({{count}})',
    structuralFocusTitle: 'На чём держится ситуация',
    structuralFocusDescription:
      'Когда линии не меняются, эти места показывают главную опору ситуации.',
    lineNumber: 'Линия {{number}}',
    changingLinesNote:
      'Прочитайте эти линии особенно внимательно: они показывают, где происходит изменение.',
  },

  // Daily Details
  dailyDetails: {
    title: 'Подробнее',
    loading: 'Загружаем знак…',
    loadError: 'Не удалось загрузить знак на выбранном языке.',
    retry: 'Повторить',
    fullText: 'Тема дня',
    situationEssence: 'Вопрос для проверки',
    innerTension: 'Что учесть',
    action: 'Что сделать сегодня',
    askAbout: 'Спросить по поводу',
    introduction:
      'Для этого знака не нужен вопрос. Он задаёт тему и практический ориентир на день.',
  },

  classicalText: {
    title: 'КЛАССИЧЕСКИЙ ТЕКСТ',
    future: 'КЛАССИКА · БУДУЩИЙ ЗНАК',
    judgment: 'ИЗРЕЧЕНИЕ ГЕКСАГРАММЫ',
    lines: 'ИЗРЕЧЕНИЯ ЛИНИЙ',
    parallelLines: 'ЛИНИИ ГЕКСАГРАММЫ',
    line: 'Линия {{number}}',
    lineStatement: 'КЛАССИЧЕСКОЕ ИЗРЕЧЕНИЕ',
    sourceLabel: 'И-Цзин',
    rulingLine: 'ГЛАВНАЯ ЛИНИЯ',
    specialLine: 'Особое изречение',
  },

  // Ask Flow
  ask: {
    throw: {
      prepare: 'Сформулируйте вопрос коротко и держите его в уме.',
      tips: {
        heart: 'Скажите, что для вас важно',
        specific: 'Опишите конкретную ситуацию',
        openEnded: 'Спросите, что стоит учесть',
      },
      example: 'Например: «Что мне стоит учесть перед решением?»',
      guide: {
        title: 'Подготовка к гаданию',
        bestTime: 'Задавайте вопрос, когда готовы спокойно рассмотреть ответ',
        todayGood: 'Перед важным решением оставьте время на проверку фактов',
      },
    },
    result: {
      sections: {
        future: 'Возможное направление',
        present: 'Что происходит сейчас',
        changes: 'Акцент чтения',
        structuralFocus: 'На чём всё держится',
        advice: 'Как поступить',
      },
      accessibility: {
        advice: 'Как поступить. Советы',
      },
      content: {
        check: 'Вопрос для проверки',
        caution: 'Что учесть',
        primaryLine: 'Основной акцент',
        secondaryLine: 'Дополнительная деталь',
        relatingHint:
          'Производная гексаграмма даёт ещё одну тему для сопоставления с ситуацией.',
        visibleStructure: 'Как складывается ситуация',
        resultStructure: 'Как может сложиться ситуация',
        hiddenDynamic: 'Что происходит глубже',
        hiddenCondition: 'Что может повлиять на результат',
        corePattern: 'Что важно заметить',
        coreTension: 'Где возникает трудность',
        question: 'Ваш вопрос',
        questionContext: 'В контексте вопроса',
        currentAction: 'Что сделать сейчас',
        entryCondition: 'Как к этому перейти',
        progressMarker: 'Как понять, что вы продвинулись',
      },
      changeDepth: {
        stable:
          'Линии не меняются. Ниже показано, на чём сейчас держится ситуация.',
        boundary: 'Изменение касается начала или завершения ситуации.',
        internal: 'Изменение затрагивает то, что происходит внутри ситуации.',
        systemic:
          'Изменение затрагивает саму основу ситуации и может изменить её ход.',
      },
      buttons: {
        decide: 'Принять решение',
      },
      more: 'Подробнее',
      skeleton: {
        loading: 'Загрузка…',
      },
    },
    acceptDecision: {
      back: 'Назад',
      title: 'Принять решение',
      subtitle: 'Добавьте контекст, чтобы позже вспомнить, о чём шла речь.',
      reading: 'Основание решения',
      questionLabel: 'О чём это решение?',
      questionPlaceholder: 'Коротко опишите ситуацию или вопрос…',
      questionHint: 'Необязательно. Контекст сохранится в дневнике.',
      confirm: 'Принять и сохранить',
      saving: 'Сохраняем…',
      cancel: 'Отмена',
      errorTitle: 'Решение не сохранено',
      errorMessage: 'Повторите попытку.',
    },
  },

  // Themes
  themes: {
    title: 'ТЕМА',
    dark: 'ТЕМНАЯ',
    light: 'СВЕТЛАЯ',
    autumn: 'ОСЕННЯЯ',
    active: 'АКТИВНАЯ',
    dark_description: 'Тёмные поверхности и спокойные акценты',
    light_description: 'Чистая, современная светлая тема',
    autumn_description: 'Теплые, земляные тона, вдохновленные осенью',
  },

  // Common UI elements
  ui: {
    screenTitle: 'ЗАГОЛОВОК ЭКРАНА',
    info: 'ИНФО',
    language: 'ЯЗЫК',
    interfaceSettings: 'Язык и тема',

    // Button loading states
    loadingStates: {
      loading: 'ЗАГРУЗКА...',
      processing: 'ОБРАБОТКА...',
      connecting: 'ПОДКЛЮЧЕНИЕ...',
      deleting: 'УДАЛЕНИЕ...',
    },
  },
  // Tabs
  tabs: {
    home: 'Дом',
    journal: 'Дневник',
    hexagrams: 'Гексаграммы',
    profile: 'Профиль',
  },
  desktop: {
    oracle: 'Оракул',
    brandSubtitle: 'И-Цзин для решений',
    appearance: 'Оформление',
    theme: 'Тема интерфейса',
  },
  hexagrams: {
    title: 'Гексаграммы',
    subtitle: '64 знака И‑Цзин — выберите удобный порядок',
    hint: 'Выберите знак, чтобы открыть его толкование',
    loading: 'Собираем каталог гексаграмм…',
    error: 'Не удалось загрузить каталог гексаграмм.',
    retry: 'Повторить',
    order: {
      title: 'Порядок',
      kingWen: '1–64',
      'king-wen': '1–64',
      fuXi: 'Фу Си',
      'fu-xi': 'Фу Си',
      mawangdui: 'Мавандуй',
    },
    matrix: {
      accessibilityLabel: 'Матрица из 64 гексаграмм. Порядок: {{order}}',
      cellAccessibilityLabel: 'Гексаграмма {{number}}. {{name}}',
    },
    modal: {
      accessibilityLabel: 'Гексаграмма {{number}}. {{name}}',
      number: 'Гексаграмма {{number}}',
      close: 'Закрыть описание гексаграммы',
      modernTitle: 'Современное толкование',
      pattern: 'Что происходит',
      tension: 'Где возникает трудность',
      structureTitle: 'Устройство ситуации',
      visibleStructure: 'Как складывается ситуация',
      hiddenDynamic: 'Что происходит глубже',
      rolesTitle: 'Роль гексаграммы',
      initialRole: 'Если знак описывает текущую ситуацию',
      resultingRole: 'Если знак становится возможным состоянием',
      roleSummary: 'Смысл роли',
      action: 'Как действовать',
      entry: 'Как войти в это состояние',
      marker: 'Признак продвижения',
      linesTitle: 'Шесть линий',
      spheresTitle: 'Действие по теме вопроса',
      spheres: {
        general: 'Ситуация или выбор',
        newjob: 'Новая работа',
        work: 'Текущая работа',
        love: 'Отношения',
        project: 'Проект',
      },
      dailyTitle: 'Ориентир на день',
      dailyFocus: 'Тема дня',
      dailyAction: 'Практический шаг',
    },
  },
  // Journal
  journal: {
    actionsFor: 'Действия с записью «{{title}}»',
    entryActions: 'Действия с записью',
    deleteConfirm: 'Удалить запись?',
    deleteEntry: 'Удалить',
    cancelDelete: 'Отмена',
    deleting: 'Удаление…',
    deleteDailyHint:
      'Этот знак будет удалён. Если он текущий, его место займёт последний оставшийся знак за эту дату. Первый знак дня сохранится.',
    deleteReadingHint:
      'Гадание и принятое по нему решение будут удалены без возможности восстановления.',
    deleteError: 'Не удалось подтвердить удаление. Попробуйте ещё раз.',
    selectEntry: 'Выберите запись в дневнике',
    entryNotFound: 'Запись не найдена. Выберите другую запись в списке.',
    title: 'Дневник',
    filters: { all: 'Все', decisions: 'Гадания', daily: 'Знак дня' },
    searchPlaceholder: 'Поиск по заголовку и заметке',
    empty: 'Здесь будут ваши гадания',
    emptyHint: 'Первое появится после «Начать гадание»',
    emptyAll: 'Здесь появятся ваши записи',
    emptyAllHint: 'Гадания и знаки дня соберутся в одном месте',
    emptyDecisions: 'Здесь появятся ваши гадания',
    emptyDecisionsHint: 'Первое появится после «Начать гадание»',
    emptyDaily: 'Здесь появятся знаки дня',
    emptyDailyHint: 'Получите первый знак на главной',
    error: 'Дневник не загрузился',
    errorHint: 'Проверьте соединение и повторите запрос',
    retry: 'Повторить',
    labels: {
      decision: 'Гадание',
      accepted: 'Гадание · решение принято',
      daily: 'Знак дня',
      question: 'Вопрос',
    },
  },
  // Profile
  profile: {
    title: 'Профиль',
    account: {
      title: 'Аккаунт',
      loginTelegram: 'Войти через Telegram',
      loginHint:
        'История аккаунта откроется на всех устройствах; локальные записи останутся на этом устройстве',
      loginUnavailable: 'Вход появится после подключения Telegram Login',
      synchronized: 'Данные аккаунта синхронизируются между устройствами',
      logout: 'Выйти из аккаунта',
      loginErrorTitle: 'Вход не выполнен',
      loginError: 'Telegram не подтвердил вход. Попробуйте ещё раз.',
      logoutErrorTitle: 'Не удалось выйти',
      logoutError: 'Проверьте соединение и повторите попытку.',
    },
    subscription: {
      title: 'Подписка',
      active: 'Активна',
      expired: 'Истекла',
      free: 'Бесплатный режим',
      activeUntil: 'Активна до {{date}}',
      manage: 'Управлять подпиской',
      connect: 'Подключить Neiro+',
      restore: 'Восстановить покупки',
      hint: 'Доступ к расширенным толкованиям, сравнениям и персональным советам.',
      restored: 'Покупки восстановлены',
      restoreError: 'Не удалось восстановить покупки',
      purchaseError: 'Не удалось оформить подписку через App Store',
      loading: 'Проверка статуса...',
      benefits: {
        extendedInterpretations: 'Расширенные толкования',
        personalAdvice: 'Персональные советы',
        comparisons: 'Сравнение вариантов',
      },
      whatsIncluded: 'Что входит?',
    },
    notifications: {
      title: 'Уведомления',
      morning: 'Утро',
      morningHint: 'Настройте время и выберите, куда присылать утренний знак',
      morningEnabledDestinationsHint:
        'Знак дня обновится в {{time}} · {{destinations}}',
      morningDisabledDestinationsHint:
        'Знак дня обновится в {{time}}, уведомления выключены',
      destinations: {
        title: 'Куда присылать',
        local: 'На этот Mac',
        telegram: 'В Telegram',
      },
      timeHint: 'Время утра',
      invalidTime: 'Введите время в формате ЧЧ:ММ, например 09:00',
      timePicker: {
        title: 'Во сколько начинается ваше утро?',
        descriptionEnabled:
          'В это время знак дня сбросится, а Telegram-бот пришлёт напоминание.',
        descriptionEnabledLocal:
          'В это время знак дня сбросится, а macOS покажет напоминание.',
        descriptionEnabledMultiple:
          'В это время знак дня сбросится, а выбранные каналы пришлют напоминание.',
        descriptionDisabled:
          'В это время знак дня сбросится. Уведомления останутся выключенными.',
        descriptionChannelUnavailable:
          'В это время знак дня сбросится. Напоминания начнут приходить, когда Telegram-канал станет доступен.',
        descriptionChannelUnavailableLocal:
          'В это время знак дня сбросится. Для напоминания macOS запросит разрешение.',
        quickChoice: 'Быстрый выбор',
        setPreset: 'Установить {{time}}',
        hours: 'Часы',
        minutes: 'Минуты',
        decreaseHours: 'Уменьшить часы на один',
        increaseHours: 'Увеличить часы на один',
        decreaseMinutes: 'Уменьшить минуты на пять',
        increaseMinutes: 'Увеличить минуты на пять',
        directEntryHint: 'Можно ввести точное значение с клавиатуры',
        invalidHours: 'В часах укажите число от 00 до 23',
        invalidMinutes: 'В минутах укажите число от 00 до 59',
      },
      loadError: 'Не удалось загрузить настройку утра',
      saveError: 'Не удалось сохранить настройку утра',
      retry: 'Повторить',
      testSent: 'Тестовое сообщение отправлено в Telegram',
      testSentLocal: 'Проверочное уведомление появится через две секунды',
      testSentMultiple: 'Проверочные уведомления отправлены в выбранные каналы',
      testError: 'Не удалось отправить тестовое сообщение',
      channel: {
        active: 'Telegram-бот готов к отправке',
        unverified: 'Откройте Telegram-бота и подтвердите получение сообщений',
        blocked: 'Telegram-бот заблокирован. Разблокируйте его в Telegram',
        disconnected: 'Связь с Telegram-ботом потеряна',
        not_connected: 'Telegram-бот ещё не подключён',
      },
      localChannel: {
        active: 'Уведомления macOS разрешены',
        unverified: 'Разрешение macOS ещё не подтверждено',
        blocked: 'Разрешите уведомления в системных настройках macOS',
        disconnected: 'Служба уведомлений macOS сейчас недоступна',
        not_connected: 'Разрешение будет запрошено при включении',
      },
      testNotification: 'Отправить тест',
    },
    preferences: {
      title: 'Предпочтения',
      haptics: 'Виброотклик',
      hapticsHint: 'Лёгкая вибрация при броске и сохранении решения',
    },
    classicalText: {
      title: 'Тексты гексаграмм',
      hint: 'Выберите современное чтение, канонический текст «Чжоу И» или оба слоя',
      modern: 'Современные',
      classical: 'Классические',
      parallel: 'Оба',
    },
    language: {
      interface: 'Язык интерфейса',
      russian: 'Русский',
      english: 'English',
    },
    data: {
      title: 'Данные и приватность',
      exportJournal: 'Экспорт дневника',
      exportPeriod: 'Период',
      allData: 'Все данные',
      last30Days: 'Последние 30 дней',
      export: 'Экспортировать',
      exportError: 'Не удалось экспортировать',
      deleteAccount: 'Удалить личные данные и аккаунт',
      deleteAccountHint:
        'Личные данные, история, настройки и аккаунт будут удалены из приложения',
      deleteAccountConfirm:
        'Данные профиля, дневник, настройки и аккаунт будут удалены. Следующий вход создаст новый аккаунт. Останутся только технические квитанции без содержимого: Telegram — на 7-дневное окно защиты, подтверждение удаления — на 30-дневное окно. После этих сроков квитанции автоматически очищаются.',
      deleteAccountError:
        'Не удалось удалить личные данные и аккаунт. Проверьте соединение и повторите попытку.',
      deleteLocalData: 'Удалить все личные данные',
      deleteLocalDataHint:
        'История и настройки этого приложения на устройстве будут удалены',
      deleteLocalDataConfirm:
        'Все данные этого приложения на устройстве будут удалены. После удаления откроется чистый начальный экран.',
      deleteLocalDataError:
        'Не удалось удалить данные этого приложения. Повторите попытку.',
      cancel: 'Отмена',
      deleteAccountAction: 'Удалить аккаунт',
      deleteLocalDataAction: 'Удалить данные',
      privacy: 'Политика конфиденциальности',
      terms: 'Условия использования',
      disclaimer:
        'Для саморефлексии и развлечения. Не является медицинской или финансовой консультацией.',
    },
    support: {
      title: 'Поддержка',
      guide: 'Как работает Oracle',
      guideHint: 'Знак дня, гадание и дневник',
      contact: 'Написать в поддержку',
      rate: 'Оценить приложение',
      rateNow: 'Оценить сейчас',
      version: 'Версия {{version}}',
      devTools: 'Dev Tools',
      devToolsDesc: 'Remote-config, тест пушей, мок-данные (заглушка)',
    },
    about: {
      title: 'О продукте',
      version: 'Версия {{version}}',
      platform: '{{platform}}',
    },
    resolveNow: 'Решить сейчас',
  },
};
